export default {"src":"/_next/static/image/public/images/social_linkedIn_blue.ce93584c6c6252e04486fdc38a378fa8.svg","height":13,"width":13};